import { render, staticRenderFns } from "./GfSettlementPolicy.vue?vue&type=template&id=8fef5fb2"
import script from "./GfSettlementPolicy.vue?vue&type=script&lang=js"
export * from "./GfSettlementPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports